import React, { ReactNode } from 'react';

import { PaymentElement } from '@stripe/react-stripe-js';
import { Button, Divider } from '@infoods/lifebase-ui';

import classes from './StripePaymentForm.module.scss';
import { PaymentButton } from '../PaymentButton/PaymentButton';
import { paymentElementsOptions } from '../../../constants/paymentElementsOptions';
import { useStripePaymentSubmit } from '../../../hooks/useStripePaymentSubmit';
import { getPriceView } from '../../../../shared/utils/stringUtils';

type PaymentButtonProps = {
  returnUrl: string;
  label: string;
  totalAmount: number;
  clientSecret: string;
};

type StripePaymentFormProps = {
  paymentButtonProps: PaymentButtonProps;
  submitDisabled?: boolean;
  /** footer content (terms checkbox, links) rendered below the pay button */
  children?: ReactNode;
};

const StripePaymentForm = ({
  paymentButtonProps,
  submitDisabled = false,
  children,
}: StripePaymentFormProps) => {
  const { handleSubmit } = useStripePaymentSubmit(paymentButtonProps.returnUrl);

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      <PaymentButton type="googlePay" {...paymentButtonProps} />
      <PaymentButton
        type="applePay"
        {...paymentButtonProps}
        className={classes.applePayButton}
      />
      <Divider className={classes.divider} flexItem textAlign="center">
        Or pay with card
      </Divider>
      <PaymentElement
        id="card-info-box" // A&A test id
        options={paymentElementsOptions}
      />
      <Button disabled={submitDisabled} variant="contained" type="submit" fullWidth>
        Pay {getPriceView(paymentButtonProps.totalAmount)}
      </Button>
      {children}
    </form>
  );
};

export { StripePaymentForm };
